// Pure helpers shared between the tracker and Playgroup Live for rendering
// Playscore score templates. No reactivity — callers wrap in `computed` (or
// equivalent) as needed.

const TRIGGER_LABELS = {
  damage: 'Damage',
  kill: 'Kill',
  win: 'Win',
  place: 'Placement',
  turn_time: 'Turn Time',
  total_turn_time: 'Total Time',
  counter: 'Manual',
  life_gain: 'Life Gain',
};

export function triggerLabel(triggerType) {
  return TRIGGER_LABELS[triggerType] || triggerType;
}

export function filterCounterRules(rules) {
  return (rules || []).filter(r => r.trigger_type === 'counter' && r.counter_id != null);
}

// Positive points first (desc), then negative points (desc). Returns a new
// array — never mutates the input.
export function sortRules(rules) {
  return [...(rules || [])].sort((a, b) => {
    if (a.points >= 0 && b.points < 0) return -1;
    if (a.points < 0 && b.points >= 0) return 1;
    return b.points - a.points;
  });
}
